import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import MuiIconButton from '@mui/material/IconButton';
import MuiTooltip from '@mui/material/Tooltip';

function IconButton({ icon, size = 'small', tooltip, ...props }) {
  return (
    tooltip ? (
      <MuiTooltip title={tooltip}>
        <MuiIconButton
          size={size}
          {...props}
        >
          <FontAwesomeIcon icon={icon} />
        </MuiIconButton>
      </MuiTooltip>
    ) : (
      <MuiIconButton size={size} {...props}>
        <FontAwesomeIcon icon={icon} />
      </MuiIconButton>
    )
  );
}

IconButton.propTypes = {
  icon: PropTypes.object.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  tooltip: PropTypes.string,
};

export default IconButton;
